<template>
  <div ref="discussBox" id="discussBox" class="discussBox">
    <div
      class="list-content"
      id="list-content"
      :class="['list-content', 'cotentPd']"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div class="list-item">
          <van-cell v-for="item in commentlists" :key="item.id" class="item">
            <div class="critic">
              <dl class="criticInfo">
                <dt class="criticImg">
                  <img
                    :src="
                      item.avatar ? item.avatar : baseUrl + 'userDefault.png'
                    "
                    alt
                  />
                </dt>
                <dd class="criticName">
                  {{ item.userName ? item.userName : "" }}
                  <span class="criticTime">{{
                    item.createTime.substr(0, 10)
                  }}</span>
                </dd>
                <dd class="criticmain">
                  <p
                    class="evauateList"
                    v-if="item.evaluateList && item.evaluateList[0]"
                  >
                    <span
                      v-for="(evaItem, index) in getChangeEvaluateList(
                        item.evaluateList
                      )"
                      :key="index"
                      :style="{
                        color: evaItem.fontColor,
                        background: evaItem.bgColor,
                      }"
                    >
                      {{ evaItem.name }}
                    </span>
                  </p>
                  <p>{{ item.content }}</p>
                  <div v-if="item.imgList != null">
                    <div
                      class="imgWrap dis_flex"
                      v-if="item.imgList.length != 4"
                    >
                      <div
                        class="img"
                        v-for="(itemUrl, index) in item.imgList"
                        :key="'dfff' + index"
                        @click="seeImg(item.imgList, index)"
                      >
                        <van-image
                          width="100%"
                          height="100%"
                          fit="cover"
                          :src="itemUrl"
                        />
                      </div>
                    </div>
                    <div class="imgWrap" v-else>
                      <div class="dis_flex">
                        <template v-for="(itemUrl, index) in item.imgList">
                          <div
                            class="img"
                            :key="index"
                            v-if="index == 0 || index == 1"
                            @click="seeImg(item.imgList, index)"
                          >
                            <van-image
                              width="100%"
                              height="100%"
                              fit="cover"
                              :src="itemUrl"
                            />
                          </div>
                        </template>
                      </div>
                      <div class="dis_flex">
                        <template v-for="(itemUrl, index) in item.imgList">
                          <div
                            class="img"
                            :key="index"
                            v-if="index == 2 || index == 3"
                            @click="seeImg(item.imgList, index)"
                          >
                            <van-image
                              width="100%"
                              height="100%"
                              fit="cover"
                              :src="itemUrl"
                            />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
          </van-cell>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import group from "@/assets/images/group.png";
export default {
  name: "comment",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      objid: "", //古树Id
      commentlists: [],
      backstagelists: [],
      NewArray: [],
      commentCount: 0,
      page: 0,
      pageSize: 20,
      contentHeight: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      group: group,
    };
  },
  props: {
    reloadType: {
      type: String,
      default: "",
    },
    appType: {
      type: String,
      default: "",
    },
  },
  created() {
    this.treeId = this.$route.query.treeId;
  },

  mounted() {
    // let winHeight = document.documentElement.clientHeight; //视口大小
    // document.getElementById("discussBox").style.height = 500 + "px"; //调整上拉加载框高度
    this.getTest();
  },
  methods: {
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }

      _this.page += 1;
      _this.$api.slbkOldTree
        .guShuComment(_this.page, _this.pageSize, _this.treeId, _this.appType)
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = res.data.total;
            _this.backstagelists = res.data.list;
            this.commentlists = this.commentlists.concat(_this.backstagelists);
            // 加载状态结束
            this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              _this.reloadType = "";
              this.$emit("getType", _this.reloadType);
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    //转换评论列表==》评价列表数组
    getChangeEvaluateList(data) {
      let dataArr = [];
      if (data && data[0]) {
        data.forEach((item) => {
          let childArr = item.split("/");
          let objData = {
            name: childArr[0],
            bgColor: childArr[1],
            fontColor: childArr[2],
          };
          dataArr.push(objData);
        });
      }
      return dataArr;
    },
    imgError(item) {
      //图片地址失效
      item.headImgUrl = this.group;
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    closeBtn() {
      let state = false;
      this.$emit("propsHide", state); //点击事件触发后，自动触发swiperhide事件
    },
    seeImg(item, index) {
      console.log(item);
      let data = {
        imgData: item,
        index: index,
      };
      this.$emit("seeImgList", data);
    },
    roloadComment() {
      let _this = this;
      _this.commentCount = 0;
      _this.page = 0;
      _this.pageSize = 20;
      _this.loading = true; //是否处于加载状态
      _this.finished = false; //是否已加载完所有数据
      _this.isLoading = false; //是否处于下拉刷新状态
      _this.commentlists = [];
      this.getTest();
    },
  },
  watch: {
    reloadType() {
      if (this.reloadType != "") {
        this.roloadComment();
      }
    },
  },
};
</script>
<style lang="less">
@import "./css/comment.less";
</style>
